import React, { Component, Fragment } from 'react';
import { connect } from 'dva';
import router from 'umi/router';
import styles from './bankcomm.less';
import { dateFormat } from 'utils/index';
import { btnBackgroundColor } from '../../utils/theme';
import { getValue } from 'utils/getValue';
import imgPayPal from 'images/payPal.png';
import imgRight from 'images/right.png';

@connect(({ home, loading, global }) => ({
  data: home.data,
  loading: loading.effects['home/queryQrcodeIndex'],
  global,
}))
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lg: 'zh-cn',
      record: {},
    };
  }

  componentDidMount() {
    const { dispatch, global = {} } = this.props;
    const urlParams = (this.props.location && this.props.location.query) || {};
    const channel = urlParams.channel || global.channel;
    const language = urlParams.language || global.lg;
    const dragoncode = getValue('dragoncode');
    const qrcode = getValue('qrcode');
    const stroageParams = localStorage.getItem('urlParams') || '{}';
    const payload = urlParams || JSON.parse(stroageParams);
    dispatch({
      type: 'home/queryQrcodeIndex',
      payload: {
        ...payload,
        dragoncode,
        qrcode,
      },
    });
    const lg = language || this.state.lg;
    const { cardType } = urlParams;
    localStorage.setItem('channel', channel);
    localStorage.setItem('language', lg);
    localStorage.setItem('urlParams', JSON.stringify(urlParams));
    this.setState({ lg, cardType });
  }

  componentWillUnmount() {
    this.timer && clearInterval(this.timer);
  }

  onchange(which) {
    this.setState({ lg: which });
    localStorage.setItem('language', which);
  }

  toUse(channel) {
    const dragoncode = localStorage.getItem('dragoncode');
    router.push({
      pathname: '/use',
      query: {
        dragoncode,
        channel,
        language: this.state.lg,
      },
    });
  }

  toSearch() {
    const dragoncode = localStorage.getItem('dragoncode');
    router.push({
      pathname: '/search',
      query: {
        dragoncode,
        language: this.state.lg,
      },
    });
  }

  toRecord(isLogin) {
    const dragoncode = localStorage.getItem('dragoncode');
    if (isLogin) {
      router.push({
        pathname: '/record',
        query: {
          dragoncode,
          language: this.state.lg,
        },
      });
    } else {
      router.push({
        pathname: '/step',
        query: {
          dragoncode,
          language: this.state.lg,
        },
      });
    }
  }
  render() {
    const query = (this.props.location && this.props.location.query) || {};
    const { data, global } = this.props;
    const { name, tips, agentName, gq } = data;
    const { dragoncode } = data.card || {};
    const { cardType } = this.state;
    const isNormal = gq === '0'; // 0正常 1过期
    if (dragoncode) localStorage.setItem('dragoncode', dragoncode);
    const channel = query.channel || global.channel;

    const isBankcomm = channel === 'bankcomm';
    const networkText = isBankcomm ? '查看休息室位置' : '服务网络';
    let userName = name || '';
    if (isBankcomm) {
      userName = userName.replace(/^./, '*');
    }

    return (
      <Fragment>
        <div className={styles.lounge}>
          <section className={styles.card}>
            <p className={styles.label}>卡号</p>
            <p className={styles.number} dangerouslySetInnerHTML={{ __html: data.dpid }}></p>
            <div className={styles.useTime}>
              <p className={styles.my}>本人无限次</p>
              {/* cardType  1年卡 不显示； 2无限 显示 */}
              <div className={styles.else}>
                <p className={styles.elseLabel}>单次免费携伴</p>
                <p className={styles.elseNum}>{String(cardType) === '2' ? 3 : 0}人</p>
              </div>
            </div>
          </section>
          <section className={styles.use}>
            <div className={styles.btnBox}>
              <div id="service" className={styles.btn} onClick={this.toSearch.bind(this)}>
                {networkText}
              </div>
              <div id="record" className={styles.btn} onClick={() => this.toRecord(data.isLogin)}>
                使用记录
              </div>
            </div>
          </section>
          <section className={styles.cardInfo}>
            <p className={styles.flex}>
              <span className={styles.label}>持卡人</span>
              <span className={styles.value}>{userName}</span>
            </p>
            <p className={styles.flex}>
              <span className={styles.label}>发卡机构</span>
              <span className={styles.value}>{agentName}</span>
            </p>
            <div className={styles.serviceInfo}>
              <h3 className={styles.label}>服务提示</h3>
              <p dangerouslySetInnerHTML={{ __html: tips }}></p>
            </div>
          </section>
          <section className={styles.bottomBtn}>
            <div
              id="use"
              className={styles.btn}
              onClick={() => this.toUse(channel)}
              style={{ background: isNormal ? btnBackgroundColor[channel] : '#cfcfcf' }}
            >
              {isNormal ? '点击生成使用凭证' : '卡已过期'}
            </div>
            {isNormal && <p style={{ color: '#999' }}>确认使用后出示刷卡码给工作人员</p>}
          </section>
        </div>
      </Fragment>
    );
  }
}

export default Home;
